import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box, styled, Switch, InputAdornment } from "@mui/material";
import { useEffect } from "react";
import { DateField, DatePicker } from "@mui/x-date-pickers";
import {
  renderEUDate,
  renderDateUTC,
  dateToServer,
} from "../../../utils/utils";
import dayjs from "dayjs";

const EditableDateInput = ({
  inputId,
  propsInitialValue,
  editMode,
  inputMode,
  setParentValue,
}) => {
  const [value, setValue] = useState(dayjs(propsInitialValue));

  const [initialValue, setInitialValue] = useState(dayjs(propsInitialValue));

  // has been focused in edit mode
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    const nextValue = dayjs(propsInitialValue);
    setValue(nextValue);
    setInitialValue(nextValue);
  }, [propsInitialValue]);

  const handleBlur = () => {
    if (value !== initialValue) {
      setTouched(true);
    }
  };

  const updateValue = (value) => {
    setValue(value);
    setParentValue(inputId, dateToServer(value));
  };

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs>
        <DatePicker
          onBlur={handleBlur}
          value={value}
          format="DD/MM/YYYY"
          onChange={(newValue) => updateValue(newValue)}
          readOnly={!editMode}
          variant="standard"
          InputProps={{
            disableUnderline: !editMode,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default EditableDateInput;
